import { throttle } from 'throttle-debounce';
import lozad from 'lozad';

export default {
  init() {
    this.headerBehaviour();
    this.scrollTo();

    const observer = lozad();
    observer.observe();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    document
      .querySelector('#toggle-menu')
      .addEventListener('click', function () {
        console.log('test');
        document.querySelector('body').classList.toggle('menu-open');
      });
  },

  headerBehaviour() {
    $(window).on(
      'scroll',
      throttle(1000, () => {
        if ($(window).scrollTop() > 90) {
          document.querySelector('body').classList.add('has-scrolled');
        } else {
          document.querySelector('body').classList.remove('has-scrolled');
        }
      })
    );
    $(window).on('scroll');
  },

  scrollTo() {
    var links = document.getElementsByTagName('a');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (
        link.href &&
        link.href.indexOf('#') != -1 &&
        (link.pathname == location.pathname ||
          '/' + link.pathname == location.pathname) &&
        link.search == location.search
      ) {
        link.onclick = this.scrollAnchors;
      }
    }
  },

  scrollAnchors(e, respond = null) {
    const distanceToTop = (el) => Math.floor(el.getBoundingClientRect().top);
    e.preventDefault();
    var targetID = respond
      ? respond.getAttribute('href')
      : this.getAttribute('href');
    let targetAnchor = document.querySelector(targetID);
    if (!targetAnchor) {
      targetAnchor = document.querySelector('section.' + targetID.substring(1));
    }
    console.log(targetAnchor);
    if (!targetAnchor) return;
    const originalTop = distanceToTop(targetAnchor);
    window.scrollBy({ top: originalTop - 50, left: 0, behavior: 'smooth' });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js